import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const resources = [{
  id: '02',
  title: 'Research Methods Assessment Vault',
  value: '24',
  desc: '300 ready-to-use questions, unit tests, final exams and complete assessments. Multiple-choice, true-or-false, short-answer, scenario-based and data interpretation tasks — including answer keys, modified versions and guidance.',
  benefit: 'Have the right assessment ready before the week begins. Open the file, choose the questions, done.'
}, {
  id: '03',
  title: 'Research Project Library',
  value: '24',
  desc: '50 complete student research projects with instructions, rubrics and teacher guidance. Includes qualitative, quantitative, mixed-methods, proposal and applied projects with suggested questions and final-product options.',
  benefit: 'Never improvise a project assignment again. Choose one, assign it, teach it.'
}, {
  id: '04',
  title: 'Real-World Research Case Study Vault',
  value: '20',
  desc: '100 ready-to-use case studies in ethics, bias, data, sources and research problems. Turn abstract concepts into real decisions through discussion, written analysis, debate, review or assessment.',
  benefit: 'Students stop memorizing definitions — and start thinking like researchers.'
}, {
  id: '05',
  title: 'Research Methods Visual Teaching Atlas',
  value: '20',
  desc: '150 visual explanations, diagrams, comparison charts and classroom references covering research design, sampling, variables, source evaluation, ethics, data collection, analysis and academic writing.',
  benefit: 'When a concept is difficult to explain with words, the visual makes it obvious.'
}, {
  id: '06',
  title: 'Research Teacher Rescue Kit',
  value: '17',
  desc: '30 no-prep emergency lessons, fast classroom activities and ready solutions for substitute days, unexpected schedule changes, early finishers and every day when your plan falls apart.',
  benefit: 'You will never walk into a Research Methods class unprepared again. Open, choose, teach.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-navy-card border-y border-navy-border" data-id="element-14" data-mp="1h5i1eyrlkcmi">
      <div className="max-w-5xl mx-auto" data-id="element-15" data-mp="1c3sn9a92viu7">
        <div className="text-center mb-16" data-id="element-16" data-mp="1q43cy9ynirds">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-17" data-mp="1q2sdgmc8o5sh">Five strategic resources, included free</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-18" data-mp="1m39qll0uxkn0">🎁 Resources 2–6: Every Gap Covered</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-19" data-mp="yajglhcilbfd">
          {resources.map((resource, index) => <motion.article key={resource.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-20" data-mp="1757nfbxqn16a" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-21" data-mp="emk6m8pry8b0">RESOURCE {resource.id}</div>
              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-22" data-mp="hjuedzjprm4"><Gift size={24} data-id="element-23" data-mp="5bxugtp5kmx4" /></div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-24" data-mp="3mr4k203p4kyd">{resource.title}</h3>
              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-25" data-mp="3rp64opgrssby"><span className="text-gray-400 text-sm" data-id="element-26" data-mp="3rnlbb366zffo">Real value: <span className="line-through" data-id="element-27" data-mp="j9mg43r1ny38">${resource.value}</span></span><span className="text-gold font-bold ml-2" data-id="element-28" data-mp="j81ha1xp5szk">→ FREE</span></div>
              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-29" data-mp="o87eryqne9pk">{resource.desc}</p>
              <p className="text-gold-light text-sm italic font-medium" data-id="element-30" data-mp="9b6qk57o0wvu">{resource.benefit}</p>
            </motion.article>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-31" data-mp="2u273q2j1oy89">
          <p className="text-gray-300 mb-2" data-id="element-32" data-mp="3fa9gyjs1b12i">Total value of the 5 strategic resources</p><p className="text-2xl text-gray-500 line-through mb-4" data-id="element-33" data-mp="3afvha56ca7s1">$105.00</p><p className="text-lg text-white mb-2" data-id="element-34" data-mp="35hk69r4b5r88">Included with your complete system today</p><p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-35" data-mp="30jimt52yzpw8">🎁 FREE</p><p className="text-sm text-gold-light" data-id="element-36" data-mp="30h5x25qz0b8m">All five resources are included with immediate access.</p>
        </motion.div>
      </div>
    </section>;
}